import { useTranslation } from 'react-i18next';
import type { LanguageCode } from '~/types/congregationGroupTypes';

export function useLanguageLabels(): Record<LanguageCode, string> {
  const { t } = useTranslation();
  return {
    en: t('wbs.english'),
    es: t('wbs.spanish'),
    fr: t('wbs.french'),
    'pt-br': t('wbs.portuguese'),
  };
}
